<div
  class="flex flex-row items-center py-3 soft-card shadow rounded flex-nowrap cursor-pointer"
  (click)="goToApplication(application)"
>
  <span
    class="application-icon rounded-md min-w-16 min-h-16 text-center items-center content-center mt-1 justify-center"
    [class]="
      showColor() && application?.color && !application?.disabled
        ? application?.color
        : 'bg-surface-tertiary text-color'
    "
  >
    @if (application?.icon !== '') {
      <soft-icon
        [name]="application?.icon"
        class="fa-2x"
        [class]="application?.disabled ? 'text-lighter' : ''"
      ></soft-icon>
    } @else {
      <i class="fa-regular fa-ban fa-3x"></i>
    }
  </span>
  <div class="flex flex-col w-full ml-3">
    <span
      class="font-bold text-xl"
      [class]="application?.disabled ? 'text-lighter' : ''"
      >{{ application?.name | translate }}</span
    >

    @if (application?.description) {
      <p class="color-light">
        {{ application?.description | translate }}
      </p>
    }
  </div>
  <div class="flex flex-col justify-center items-center p-2">
    @if (application?.type === 'link') {
      <soft-icon
        name="fa-regular fa-arrow-up-right-from-square"
        class="text-sm color-lighter"
      ></soft-icon>
    } @else {
      <i class="fa-regular fa-chevron-right color-lighter"></i>
    }
  </div>
</div>
